webpackJsonp([35783957827783],{

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/current-projects.1fa60740.svg";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/register-now.91d3b44b.svg";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/review-logo.2a93f1bc.svg";

/***/ }),

/***/ 525:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/india_character_home.77270b31.svg";

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(9);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(491);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	var _index = __webpack_require__(526);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _engr_psah = __webpack_require__(525);
	
	var _engr_psah2 = _interopRequireDefault(_engr_psah);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SimpleSlider = function (_React$Component) {
	  (0, _inherits3.default)(SimpleSlider, _React$Component);
	
	  function SimpleSlider() {
	    (0, _classCallCheck3.default)(this, SimpleSlider);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SimpleSlider.prototype.render = function render() {
	
	    var settings = {
	      dots: true,
	      infinite: false,
	      draggable: false,
	      speed: 500,
	      slidesToScroll: 1,
	      centerMode: true,
	      responsive: [{ breakpoint: 992, settings: { slidesToShow: 1, centerMode: false, draggable: true, adaptiveHeight: true } }, { breakpoint: 100000, settings: { slidesToShow: 3 } }]
	    };
	    return _react2.default.createElement(
	      _reactSlick2.default,
	      settings,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _engr_psah2.default, alt: 'Engr. PSAH' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Engr. PSAH'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.trustpilot.com/reviews/5aba01a96d33bc08ec85accd', target: '_blank' },
	              'TrustPilot'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'Overall i am satisfied with the work\u2026'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'Overall i am satisfied with the work load in this season and the diversity of the orders helped me to increase my analytical and researcher skills.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _index2.default, alt: 'Writer\'s ID #28612*' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Writer\'s ID #28612*'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: ("https://uvocorp.com") + '/reviews.html#28612*' },
	              'UvoCorp'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'It\'s very beneficial to work with you!'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'Although more legal orders would be nice to have, in general Uvo corp is a must for both people that are beginners in remote writing! It also accommodates experienced writers very well. You are very consistent with everything written in the FAQs...'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _index2.default, alt: 'Stephen Mwaniki' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Stephen Mwaniki'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.trustpilot.com/reviews/5a8fa31bd27b0a0594d03241', target: '_blank' },
	              'TrustPilot'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'Always the Best'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'UvoCorp is one of the best companies that i have worked for. I have been a freelancer in it for less than four months but what i have learnt over the period is more than what i can imagine. The reward per page is awesome, and it inspires me to work harder to increase my earnings... '
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _index2.default, alt: 'Writer\'s ID #26272*' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Writer\'s ID #26272*'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: ("https://uvocorp.com") + '/reviews.html#26272*' },
	              'UvoCorp'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'It is very beneficial to work with the company.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'There is a constant flow of orders for the most part of the year, the payment department is fast, efficient, and supports several payment methods and the support team as well as company regulations are excellent, easy to work with, and foster professionalism.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _index2.default, alt: 'Oduor Fredrick' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Oduor Fredrick'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.trustpilot.com/users/5a71e1790000ff000b0b4612', target: '_blank' },
	              'TrustPilot'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'Simply the Best'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'I have been with Uvocorp fo 9 years. It is the best freelance writing company. The selling points of the company are good pay per page and unwillingness to fine writers unless a case has been reviewed extensively. I recommend the company to any budding writer.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _index2.default, alt: 'Writer\'s ID #25570*' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Writer\'s ID #25570*'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: ("https://uvocorp.com") + '/reviews.html#25570*' },
	              'UvoCorp'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'It is GREAT!'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'I love working with you, I can be ill and still not discouraged because of it, I can be at a remote location, but still have an opportunity to finish assignments, which means for me advancing of my skills and flourishing of my vocabulary! I also feel that I can help those who need assistance.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _index2.default, alt: 'Stephen Mwangi' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Stephen Mwangi'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.trustpilot.com/reviews/5a6c35e66116dd0e940eb1f3', target: '_blank' },
	              'TrustPilot'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'A Land of Opportunity'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'A company where the writer\u2019s effort is appreciated in all ways possible. The support is very professional and ready to assist 24/7. There are sufficient orders, which are handsomely rewarded. The site is easy to use as it is self-explanatory...'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _index2.default, alt: 'Writer\'s ID #12810*' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Writer\'s ID #12810*'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: ("https://uvocorp.com") + '/reviews.html#12810*' },
	              'UvoCorp'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'Excellent'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'I find UVOCORP as a highly professional site for freelance writers. I appreciate and am grateful to be part of this company in more than three years now. I\'m looking forward to continuously working with you and witness all improvements and progress.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'slider-item' },
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-avatar' },
	            _react2.default.createElement('img', { src: _index2.default, alt: 'Nisa S' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-name' },
	            'Nisa S'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-rating' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'rating' },
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', null),
	              _react2.default.createElement('li', { className: 'rating-empty' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-publish' },
	            'Published on ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.trustpilot.com/reviews/5a5e6f736116dd0614de55f1', target: '_blank' },
	              'TrustPilot'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-title' },
	            'The company itself is professional and \u2026'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'slider-item-text' },
	            'The company itself is professional and provides necessary support to writers, but the nature of the work is that writing for academia takes time and the compensation is not on par with the effort and skills required for producing well-written material. But that\'s just what it is, I suppose - don\'t expect to make money you can live on by doing this.'
	          )
	        )
	      )
	    );
	  };
	
	  return SimpleSlider;
	}(_react2.default.Component);
	
	exports.default = SimpleSlider;
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(9);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(50);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(49);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _slider = __webpack_require__(228);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _rcCollapse = __webpack_require__(399);
	
	var _rcCollapse2 = _interopRequireDefault(_rcCollapse);
	
	var _india_character_home = __webpack_require__(527);
	
	var _india_character_home2 = _interopRequireDefault(_india_character_home);
	
	var _reviewLogo = __webpack_require__(524);
	
	var _reviewLogo2 = _interopRequireDefault(_reviewLogo);
	
	var _trustpilotLogo = __webpack_require__(528);
	
	var _trustpilotLogo2 = _interopRequireDefault(_trustpilotLogo);
	
	var _currentProjects = __webpack_require__(519);
	
	var _currentProjects2 = _interopRequireDefault(_currentProjects);
	
	var _registerNow = __webpack_require__(523);
	
	var _registerNow2 = _interopRequireDefault(_registerNow);
	
	var _cover = __webpack_require__(91);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function (_React$Component) {
		(0, _inherits3.default)(Index, _React$Component);
	
		function Index() {
			(0, _classCallCheck3.default)(this, Index);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
			_this.state = {
				average: '',
				averageOrders: '',
				totalNumberOfReviews: '',
				trustScore: '',
				currentRatingWord: '',
				ratingWord: '',
				ratingListWord: ["Bad", "Poor", "Average", "Great", "Excellent"]
			};
	
			return _this;
		}
	
		Index.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Index.prototype.componentDidMount = function componentDidMount() {
			var self = this;
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
	
			if (!document.getElementById('available_total')) {
				window.logIt = function (data) {
					self.setState({ average: data.avg });
					self.setState({ averageOrders: data.count });
				}.bind(self);
	
				(function (d, s, id) {
					var js,
					    fjs = d.getElementsByTagName(s)[0];
					if (d.getElementById(id)) return;
					js = d.createElement(s);js.id = id;
					js.src = ("https://uvocorp.com") + '/api/orders/available/total?callback=logIt&jsonp=true';
					fjs.parentNode.insertBefore(js, fjs);
				})(document, 'script', 'available_total');
			}
	
			if (!document.getElementById('trustpilot_widget')) {
				window.trustpilot = function (data) {
					self.setState({ totalNumberOfReviews: data.ratingsTotalCount });
					self.setState({ trustScore: data.trustScore });
	
					self.setState({ currentRatingWord: Math.ceil(data.trustScore * 5 / 5) });
					self.setState({ ratingWord: self.state.ratingListWord[self.state.currentRatingWord - 1] });
				}.bind(self);
	
				(function (d, s, id) {
					var js,
					    fjs = d.getElementsByTagName(s)[0];
					if (d.getElementById(id)) return;
					js = d.createElement(s);js.id = id;
					js.src = ("https://uvocorp.com") + '/api/trustpilot/54229a4300006400057a8430?callback=trustpilot&jsonp=true';
					fjs.parentNode.insertBefore(js, fjs);
				})(document, 'script', 'trustpilot_widget');
			}
		};
	
		Index.prototype.componentWillUnmount = function componentWillUnmount() {
			var totalId = document.getElementById('available_total'),
			    trustpilot_widget = document.getElementById('trustpilot_widget');
			totalId.parentNode.removeChild(totalId);
			trustpilot_widget.parentNode.removeChild(trustpilot_widget);
		};
	
		Index.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Freelance Writing Jobs in India. Online Writing Jobs - India.UvoCorp.com",
					meta: [{ name: "description", content: "Freelance writing jobs online in India. Apply for a job online with India.UvoCorp.com Registration is free." }, { property: 'og:title', content: "Freelance Writing Jobs in India. Online Writing Jobs - India.UvoCorp.com" }, { property: 'og:description', content: "Freelance writing jobs online in India. Apply for a job online with India.UvoCorp.com Registration is free." }, { property: 'og:site_name', content: "India.UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://india.uvocorp.com/" }, { rel: 'alternate', href: "https://www.uvocorp.com", hrefLang: "en" }, { rel: 'alternate', href: "https://canada.uvocorp.com", hrefLang: "en-ca" }, { rel: 'alternate', href: "https://hongkong.uvocorp.com", hrefLang: "en-hk" }, { rel: 'alternate', href: "https://india.uvocorp.com", hrefLang: "en-in" }, { rel: 'alternate', href: "https://nigeria.uvocorp.com", hrefLang: "en-ng" }, { rel: 'alternate', href: "https://pakistan.uvocorp.com", hrefLang: "en-pk" }, { rel: 'alternate', href: "https://philippines.uvocorp.com", hrefLang: "en-ph" }, { rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-pl" }, { rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-ro" }, { rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-bg" }, { rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-md" }, { rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-ua" }] }),
				_react2.default.createElement(
					"div",
					{ className: "home-navigation" },
					_react2.default.createElement(
						"div",
						{ className: "header", id: "header" },
						_react2.default.createElement(_navigation2.default, null)
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper subdomen" },
					_react2.default.createElement(
						"div",
						{ className: "home-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "home-header-image" },
								_react2.default.createElement(
									"div",
									{ className: "img home-header-img" },
									_react2.default.createElement("img", { id: "home-header-img", src: _india_character_home2.default })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "home-header-text" },
								_react2.default.createElement(
									"div",
									{ className: "home-header-title" },
									"India"
								),
								_react2.default.createElement(
									"div",
									{ className: "home-header-subtitle" },
									"ACADEMIC WRITING ASSISTANCE AGENCY"
								),
								_react2.default.createElement(
									"div",
									{ className: "home-header-button" },
									_react2.default.createElement(
										"a",
										{ href: ("https://uvocorp.com") + "/register_email.html" },
										"Register now"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-pricing-info" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"p",
								null,
								"There is no other company that offers ",
								_react2.default.createElement(
									"strong",
									null,
									"$15"
								),
								"/page written by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ESL"
								),
								" writer and ",
								_react2.default.createElement(
									"strong",
									null,
									"$26"
								),
								"/page completed by an ",
								_react2.default.createElement(
									"span",
									{ className: "home-pricing-info-role" },
									"ENL"
								),
								" writer."
							),
							_react2.default.createElement(
								"a",
								{ href: ("https://uvocorp.com") + "/prices.html" },
								"View Pricing ",
								_react2.default.createElement(
									"svg",
									{ id: "arrow-right", width: "22", height: "22" },
									_react2.default.createElement("path", { fill: "#black", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-benefits home-block-gray" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"The benefits you enjoy working as a freelance writer:"
							),
							_react2.default.createElement(
								"ul",
								{ className: "home-benefits-list" },
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-1" },
									_react2.default.createElement(
										"p",
										null,
										"No registration fees"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-2" },
									_react2.default.createElement(
										"p",
										null,
										"High wages"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-3" },
									_react2.default.createElement(
										"p",
										null,
										"Working from home"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-4" },
									_react2.default.createElement(
										"p",
										null,
										"Orders in the sphere ",
										_react2.default.createElement("br", null),
										"of your interest"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-5" },
									_react2.default.createElement(
										"p",
										null,
										"24/7 available ",
										_react2.default.createElement("br", null),
										"support team"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-6" },
									_react2.default.createElement(
										"p",
										null,
										"Payments always ",
										_react2.default.createElement("br", null),
										"on time"
									)
								),
								_react2.default.createElement(
									"li",
									{ className: "home-benefits-7" },
									_react2.default.createElement(
										"p",
										null,
										"Manage your time ",
										_react2.default.createElement("br", null),
										"and workload yourself"
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-block" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								null,
								"Current projects offered"
							),
							_react2.default.createElement(
								"div",
								{ className: "row" },
								_react2.default.createElement(
									"div",
									{ className: "col-sm-6" },
									_react2.default.createElement(
										"div",
										{ className: "home-block-img" },
										_react2.default.createElement("img", { src: _currentProjects2.default, alt: "Current projects offered" })
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-sm-6 home-current-projects-text" },
									_react2.default.createElement(
										"p",
										null,
										"Average order price: ",
										_react2.default.createElement(
											"strong",
											{ className: "home-teal-color" },
											"$",
											this.state.average
										)
									),
									_react2.default.createElement(
										"p",
										null,
										"Currently available orders: ",
										_react2.default.createElement(
											"strong",
											{ className: "home-teal-color" },
											this.state.averageOrders
										)
									),
									_react2.default.createElement(
										"p",
										{ className: "home-current-projects-link" },
										_react2.default.createElement(
											"a",
											{ href: ("https://uvocorp.com") + "/view_all_orders.html" },
											"View all orders ",
											_react2.default.createElement(
												"svg",
												{ id: "arrow-right", width: "22", height: "22" },
												_react2.default.createElement("path", { fill: "#f29f22", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
											)
										)
									)
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "row subdomen-collapse" },
								_react2.default.createElement(
									"div",
									{ className: "col-md-8" },
									_react2.default.createElement(
										_rcCollapse2.default,
										{ accordion: true, defaultActiveKey: "0" },
										_react2.default.createElement(
											_rcCollapse.Panel,
											{ header: "Freelance Writing Jobs in India" },
											_react2.default.createElement(
												"p",
												null,
												"Have you ever thought of investing your skills and a bit of free time to ",
												_react2.default.createElement(
													_gatsbyLink2.default,
													{ to: "/make_money_writing_online.html", title: "Earn More Money" },
													"earn more money"
												),
												" than you get every month? Have you ever been dissatisfied with your income? But it is not easy working two jobs, or studying and working part-time. You would need twice as much time to get from one place to another and that would cut the time you could spare for another job. In addition, it is very stressful for your body and mind which, in turn, lowers the physical and intellectual productivity of most people."
											)
										),
										_react2.default.createElement(
											_rcCollapse.Panel,
											{ header: "Is There an Alternative?" },
											_react2.default.createElement(
												"p",
												null,
												"Of course, there is always an alternative. The solution to your problem is an online job. There are a lot of online writing jobs in India to choose from, that are available on the Internet, although it is advisable to choose a company to work for as carefully as you would while looking for a full-time, or ",
												_react2.default.createElement(
													_gatsbyLink2.default,
													{ to: "/writing_jobs_from_home.html", title: "Part-Time Job" },
													"part-time job"
												),
												" at any other place. "
											)
										),
										_react2.default.createElement(
											_rcCollapse.Panel,
											{ header: "Benefits of Being a Freelancer" },
											_react2.default.createElement(
												"p",
												null,
												"Freelance writing jobs in India carry a lot of benefits for people who like writing and those who need some extra cash. First of all, you chose the workload yourself so you can easily manage your own time and plan your working schedule beforehand. There is no boss to pressure you with deadlines you won't be able to meet and the amount of work that you won't be able to do."
											),
											_react2.default.createElement(
												"p",
												null,
												"It is always hard to find a well paid job if you have no experience, especially when you are seeking jobs for writers in India. You do not need experience to apply as a freelance writer, since it is your academic skills that matter. They will be assessed in the registration process, and not the time you have spent working for some company, or companies. Another important thing you need to become a freelance writer is a reliable Internet connection, which is not an issue for most people nowadays. Also, you have the freedom to choose the area, or areas, in which you wish to write. You do not have to write about something that is not familiar to you."
											),
											_react2.default.createElement(
												"p",
												null,
												"Another benefit of being a freelance writer is that it gives you more guarantees of a stable income than half of the companies to which you apply as a writer. Moreover, you get paid twice a month through a convenient and reliable paying method that is available, in most locations, worldwide.  A good company makes sure that all your personal information stays confidential and that no third party will get it."
											)
										),
										_react2.default.createElement(
											_rcCollapse.Panel,
											{ header: "A job well-done" },
											_react2.default.createElement(
												"p",
												null,
												"Get paid to write all sorts of academic papers to help others who are in need of them. You will be able to communicate directly with the customer, if you need to clarify any point relating to the paper, so that you know you are doing the right thing."
											),
											_react2.default.createElement(
												"p",
												null,
												"And furthermore, if you are applying for a freelance ",
												_react2.default.createElement(
													_gatsbyLink2.default,
													{ to: "/online_writing_jobs.html", title: "Writing Job" },
													"writing job"
												),
												" as a part-time way to earn some money - who knows? Maybe you will like it so much that you start working full-time. It's up to you in what field of study you write, how you manage your time and how much you earn."
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-block-gray home-block-gray-calltoaction" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"p",
								null,
								"Do you want to see the full pricing policy? ",
								_react2.default.createElement(
									"a",
									{ href: ("https://uvocorp.com") + "/prices.html" },
									"Pricing Policy"
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-block" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								null,
								"What our writers say"
							),
							_react2.default.createElement(_slider2.default, null),
							_react2.default.createElement(
								"div",
								{ className: "trast" },
								_react2.default.createElement(
									"div",
									{ className: "trast-avatar" },
									_react2.default.createElement("img", { src: _reviewLogo2.default, alt: "avatar for trustpilot.com" })
								),
								_react2.default.createElement(
									"div",
									{ className: "trast-info" },
									_react2.default.createElement(
										"div",
										{ className: "trast-info-rating-stars" },
										_react2.default.createElement(
											"ul",
											{ className: "rating" },
											this.state.trustScore < 1 ? _react2.default.createElement("li", { className: "rating-empty" }) : _react2.default.createElement("li", null),
											this.state.trustScore < 2 ? _react2.default.createElement("li", { className: "rating-empty" }) : _react2.default.createElement("li", null),
											this.state.trustScore < 3 ? _react2.default.createElement("li", { className: "rating-empty" }) : _react2.default.createElement("li", null),
											this.state.trustScore < 4 ? _react2.default.createElement("li", { className: "rating-empty" }) : _react2.default.createElement("li", null),
											this.state.trustScore < 5 ? _react2.default.createElement("li", { className: "rating-empty" }) : _react2.default.createElement("li", null)
										)
									),
									_react2.default.createElement(
										"div",
										{ className: "trast-info-rating" },
										this.state.ratingWord,
										" ",
										this.state.trustScore,
										" ",
										_react2.default.createElement(
											"span",
											{ className: "trast-info-gray" },
											"from 0 - 5"
										)
									),
									_react2.default.createElement(
										"div",
										{ className: "trast-info-based" },
										_react2.default.createElement(
											"span",
											{ className: "trast-info-gray" },
											"based on ",
											this.state.totalNumberOfReviews,
											" reviews"
										),
										_react2.default.createElement("img", { src: _trustpilotLogo2.default, width: "106", height: "13", alt: "trustpilot.com" })
									),
									_react2.default.createElement(
										"div",
										{ className: "trast-info-link" },
										_react2.default.createElement(
											"a",
											{ href: "https://www.trustpilot.com/review/uvocorp.com", target: "_blank" },
											"See more reviews ",
											_react2.default.createElement(
												"svg",
												{ id: "arrow-right", width: "22", height: "22" },
												_react2.default.createElement("path", { fill: "#1164c2", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-registration" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "home-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "home-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "home-registration-button" },
									_react2.default.createElement(
										"a",
										{ href: ("https://uvocorp.com") + "/register_email.html" },
										"Start registration"
									)
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "home-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img home-registration-img" },
									_react2.default.createElement("img", { src: _registerNow2.default, alt: "Start registration" })
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	module.exports = exports["default"];

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(146);
	} catch (err) {
	  var index = __webpack_require__(146);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ }),

/***/ 146:
/***/ (function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(174);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),

/***/ 331:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START_EVENT_NAME_MAP = {
	  transitionstart: {
	    transition: 'transitionstart',
	    WebkitTransition: 'webkitTransitionStart',
	    MozTransition: 'mozTransitionStart',
	    OTransition: 'oTransitionStart',
	    msTransition: 'MSTransitionStart'
	  },
	
	  animationstart: {
	    animation: 'animationstart',
	    WebkitAnimation: 'webkitAnimationStart',
	    MozAnimation: 'mozAnimationStart',
	    OAnimation: 'oAnimationStart',
	    msAnimation: 'MSAnimationStart'
	  }
	};
	
	var END_EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var startEvents = [];
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete START_EVENT_NAME_MAP.animationstart.animation;
	    delete END_EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete START_EVENT_NAME_MAP.transitionstart.transition;
	    delete END_EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  function process(EVENT_NAME_MAP, events) {
	    for (var baseEventName in EVENT_NAME_MAP) {
	      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	        var baseEvents = EVENT_NAME_MAP[baseEventName];
	        for (var styleName in baseEvents) {
	          if (styleName in style) {
	            events.push(baseEvents[styleName]);
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  process(START_EVENT_NAME_MAP, startEvents);
	  process(END_EVENT_NAME_MAP, endEvents);
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  // Start events
	  startEvents: startEvents,
	
	  addStartEventListener: function addStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      addEventListener(node, startEvent, eventListener);
	    });
	  },
	  removeStartEventListener: function removeStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      removeEventListener(node, startEvent, eventListener);
	    });
	  },
	
	
	  // End events
	  endEvents: endEvents,
	
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(93);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(331);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(246);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(341);
	var each = __webpack_require__(177).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(339);
	var Util = __webpack_require__(177);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ }),

/***/ 341:
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ }),

/***/ 177:
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(340);
	module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(514);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(51);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(243);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(9);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(145);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(401);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	var _ChildrenUtils = __webpack_require__(395);
	
	var _AnimateChild = __webpack_require__(394);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(183);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = (0, _unsafeLifecyclesPolyfill2['default'])(Animate);
	module.exports = exports['default'];

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(9);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(145);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(175);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(183);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any,
	  animation: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Panel = __webpack_require__(397);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _openAnimationFactory = __webpack_require__(400);
	
	var _openAnimationFactory2 = _interopRequireDefault(_openAnimationFactory);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIs = __webpack_require__(206);
	
	var _shallowequal = __webpack_require__(90);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _reactLifecyclesCompat = __webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function toArray(activeKey) {
	  var currentActiveKey = activeKey;
	  if (!Array.isArray(currentActiveKey)) {
	    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
	  }
	  return currentActiveKey.map(function (key) {
	    return String(key);
	  });
	}
	
	var Collapse = function (_Component) {
	  _inherits(Collapse, _Component);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var activeKey = props.activeKey,
	        defaultActiveKey = props.defaultActiveKey;
	
	    var currentActiveKey = defaultActiveKey;
	    if ('activeKey' in props) {
	      currentActiveKey = activeKey;
	    }
	
	    _this.state = {
	      openAnimation: props.openAnimation || (0, _openAnimationFactory2['default'])(props.prefixCls),
	      activeKey: toArray(currentActiveKey)
	    };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          className = _props.className,
	          style = _props.style,
	          accordion = _props.accordion;
	
	      var collapseClassName = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
	      return _react2['default'].createElement(
	        'div',
	        { className: collapseClassName, style: style, role: accordion ? 'tablist' : null },
	        this.getItems()
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	      if ('activeKey' in nextProps) {
	        newState.activeKey = toArray(nextProps.activeKey);
	      }
	      if ('openAnimation' in nextProps) {
	        newState.openAnimation = nextProps.openAnimation;
	      }
	      return newState.activeKey || newState.openAnimation ? newState : null;
	    }
	  }]);
	
	  return Collapse;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onClickItem = function (key) {
	    var activeKey = _this2.state.activeKey;
	    if (_this2.props.accordion) {
	      activeKey = activeKey[0] === key ? [] : [key];
	    } else {
	      activeKey = [].concat(_toConsumableArray(activeKey));
	      var index = activeKey.indexOf(key);
	      var isActive = index > -1;
	      if (isActive) {
	        // remove active state
	        activeKey.splice(index, 1);
	      } else {
	        activeKey.push(key);
	      }
	    }
	    _this2.setActiveKey(activeKey);
	  };
	
	  this.getNewChild = function (child, index) {
	    if (!child) return null;
	
	    var activeKey = _this2.state.activeKey;
	    var _props2 = _this2.props,
	        prefixCls = _props2.prefixCls,
	        accordion = _props2.accordion,
	        destroyInactivePanel = _props2.destroyInactivePanel,
	        expandIcon = _props2.expandIcon;
	    // If there is no key provide, use the panel order as default key
	
	    var key = child.key || String(index);
	    var _child$props = child.props,
	        header = _child$props.header,
	        headerClass = _child$props.headerClass,
	        disabled = _child$props.disabled;
	
	    var isActive = false;
	    if (accordion) {
	      isActive = activeKey[0] === key;
	    } else {
	      isActive = activeKey.indexOf(key) > -1;
	    }
	
	    var props = {
	      key: key,
	      panelKey: key,
	      header: header,
	      headerClass: headerClass,
	      isActive: isActive,
	      prefixCls: prefixCls,
	      destroyInactivePanel: destroyInactivePanel,
	      openAnimation: _this2.state.openAnimation,
	      accordion: accordion,
	      children: child.props.children,
	      onItemClick: disabled ? null : _this2.onClickItem,
	      expandIcon: expandIcon
	    };
	
	    return _react2['default'].cloneElement(child, props);
	  };
	
	  this.getItems = function () {
	    var children = _this2.props.children;
	
	    var childList = (0, _reactIs.isFragment)(children) ? children.props.children : children;
	    var newChildren = _react.Children.map(childList, _this2.getNewChild);
	
	    //  ref: https://github.com/ant-design/ant-design/issues/13884
	    if ((0, _reactIs.isFragment)(children)) {
	      return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        newChildren
	      );
	    }
	
	    return newChildren;
	  };
	
	  this.setActiveKey = function (activeKey) {
	    if (!('activeKey' in _this2.props)) {
	      _this2.setState({ activeKey: activeKey });
	    }
	    _this2.props.onChange(_this2.props.accordion ? activeKey[0] : activeKey);
	  };
	};
	
	Collapse.propTypes = {
	  children: _propTypes2['default'].any,
	  prefixCls: _propTypes2['default'].string,
	  activeKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]))]),
	  defaultActiveKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]))]),
	  openAnimation: _propTypes2['default'].object,
	  onChange: _propTypes2['default'].func,
	  accordion: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  expandIcon: _propTypes2['default'].func
	};
	
	Collapse.defaultProps = {
	  prefixCls: 'rc-collapse',
	  onChange: function onChange() {},
	
	  accordion: false,
	  destroyInactivePanel: false
	};
	
	Collapse.Panel = _Panel2['default'];
	
	(0, _reactLifecyclesCompat.polyfill)(Collapse);
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PanelContent = __webpack_require__(398);
	
	var _PanelContent2 = _interopRequireDefault(_PanelContent);
	
	var _rcAnimate = __webpack_require__(393);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _shallowequal = __webpack_require__(90);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsePanel = function (_Component) {
	  _inherits(CollapsePanel, _Component);
	
	  function CollapsePanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CollapsePanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function () {
	      var _this$props = _this.props,
	          onItemClick = _this$props.onItemClick,
	          panelKey = _this$props.panelKey;
	
	
	      if (typeof onItemClick === 'function') {
	        onItemClick(panelKey);
	      }
	    }, _this.handleKeyPress = function (e) {
	      if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
	        _this.handleItemClick();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CollapsePanel, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowequal2['default'])(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames2;
	
	      var _props = this.props,
	          className = _props.className,
	          id = _props.id,
	          style = _props.style,
	          prefixCls = _props.prefixCls,
	          header = _props.header,
	          headerClass = _props.headerClass,
	          children = _props.children,
	          isActive = _props.isActive,
	          showArrow = _props.showArrow,
	          destroyInactivePanel = _props.destroyInactivePanel,
	          disabled = _props.disabled,
	          accordion = _props.accordion,
	          forceRender = _props.forceRender,
	          expandIcon = _props.expandIcon,
	          extra = _props.extra;
	
	      var headerCls = (0, _classnames2['default'])(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
	      var itemCls = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);
	
	      var icon = _react2['default'].createElement('i', { className: 'arrow' });
	      if (showArrow && typeof expandIcon === 'function') {
	        icon = expandIcon(this.props);
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: itemCls, style: style, id: id },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: headerCls,
	            onClick: this.handleItemClick,
	            role: accordion ? 'tab' : 'button',
	            tabIndex: disabled ? -1 : 0,
	            'aria-expanded': '' + isActive,
	            onKeyPress: this.handleKeyPress
	          },
	          showArrow && icon,
	          header,
	          extra && _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-extra' },
	            extra
	          )
	        ),
	        _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            showProp: 'isActive',
	            exclusive: true,
	            component: '',
	            animation: this.props.openAnimation
	          },
	          _react2['default'].createElement(
	            _PanelContent2['default'],
	            {
	              prefixCls: prefixCls,
	              isActive: isActive,
	              destroyInactivePanel: destroyInactivePanel,
	              forceRender: forceRender,
	              role: accordion ? 'tabpanel' : null
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return CollapsePanel;
	}(_react.Component);
	
	CollapsePanel.propTypes = {
	  className: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  id: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  openAnimation: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  header: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].node]),
	  headerClass: _propTypes2['default'].string,
	  showArrow: _propTypes2['default'].bool,
	  isActive: _propTypes2['default'].bool,
	  onItemClick: _propTypes2['default'].func,
	  style: _propTypes2['default'].object,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  accordion: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  expandIcon: _propTypes2['default'].func,
	  extra: _propTypes2['default'].node,
	  panelKey: _propTypes2['default'].any
	};
	
	CollapsePanel.defaultProps = {
	  showArrow: true,
	  isActive: false,
	  destroyInactivePanel: false,
	  onItemClick: function onItemClick() {},
	
	  headerClass: '',
	  forceRender: false
	};
	
	exports['default'] = CollapsePanel;
	module.exports = exports['default'];

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(32);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _shallowequal = __webpack_require__(90);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PanelContent = function (_Component) {
	  _inherits(PanelContent, _Component);
	
	  function PanelContent() {
	    _classCallCheck(this, PanelContent);
	
	    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
	  }
	
	  _createClass(PanelContent, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.forceRender || !(0, _shallowequal2['default'])(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      this._isActived = this.props.forceRender || this._isActived || this.props.isActive;
	      if (!this._isActived) {
	        return null;
	      }
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          isActive = _props.isActive,
	          children = _props.children,
	          destroyInactivePanel = _props.destroyInactivePanel,
	          forceRender = _props.forceRender,
	          role = _props.role;
	
	      var contentCls = (0, _classnames3['default'])((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
	      var child = !forceRender && !isActive && destroyInactivePanel ? null : _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-content-box' },
	        children
	      );
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: contentCls,
	          role: role
	        },
	        child
	      );
	    }
	  }]);
	
	  return PanelContent;
	}(_react.Component);
	
	PanelContent.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  isActive: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string
	};
	
	exports['default'] = PanelContent;
	module.exports = exports['default'];

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = undefined;
	
	var _Collapse = __webpack_require__(396);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Collapse2['default'];
	var Panel = exports.Panel = _Collapse2['default'].Panel;

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cssAnimation = __webpack_require__(175);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function animate(node, show, transitionName, done) {
	  var height = void 0;
	  return (0, _cssAnimation2['default'])(node, transitionName, {
	    start: function start() {
	      if (!show) {
	        node.style.height = node.offsetHeight + 'px';
	      } else {
	        height = node.offsetHeight;
	        node.style.height = 0;
	      }
	    },
	    active: function active() {
	      node.style.height = (show ? height : 0) + 'px';
	    },
	    end: function end() {
	      node.style.height = '';
	      done();
	    }
	  });
	}
	
	function animation(prefixCls) {
	  return {
	    enter: function enter(node, done) {
	      return animate(node, true, prefixCls + '-anim', done);
	    },
	    leave: function leave(node, done) {
	      return animate(node, false, prefixCls + '-anim', done);
	    }
	  };
	}
	
	exports['default'] = animation;
	module.exports = exports['default'];

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  } // only handle componentWillReceiveProps
	
	
	  if (typeof prototype.componentWillReceiveProps !== 'function') {
	    return Component;
	  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
	  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler
	
	
	  if (!_react.default.Profiler) {
	    return Component;
	  } // Here polyfill get started
	
	
	  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
	  delete prototype.componentWillReceiveProps;
	  return Component;
	};
	
	var _default = unsafeLifecyclesPolyfill;
	exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(141);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    // init: function hook that gets called right before InnerSlider mounts
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow should react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	exports.default = defaultProps;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(495);

/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(494);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(141);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(492);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(212);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(330);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(496);
	
	var _dots = __webpack_require__(490);
	
	var _arrows = __webpack_require__(489);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null, // wraps the track
	  track: null, // component that rolls out like a film
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    // number of slides shown in the active frame
	    var slidesToShow = this.props.slidesToShow;
	    var childrenLen = _react2.default.Children.count(this.props.children);
	    var currentSlide = this.state.currentSlide;
	    for (var i = 0; i < childrenLen; i++) {
	      // if currentSlide is the lastSlide of current frame and 
	      // rest of the active slides are on the left of currentSlide
	      // then the following might cause a problem
	      if (i >= currentSlide && i < currentSlide + slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	    if (this.props.centerMode === true) {
	      // add slides to show on the left in case of centerMode with lazyLoad
	      var additionalCount = Math.floor(slidesToShow / 2);
	      if (parseInt(this.props.centerPadding) > 0) {
	        additionalCount += 1;
	      }
	      var additionalNum = currentSlide;
	      while (additionalCount--) {
	        lazyLoadedList.push((--additionalNum + childrenLen) % childrenLen);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.lazyLoad && this.props.centerMode) {
	      var childrenLen = _react2.default.Children.count(this.props.children);
	      var additionalCount = Math.floor(this.props.slidesToShow / 2);
	      if (parseInt(this.props.centerPadding) > 0) additionalCount++;
	      var leftMostSlide = (this.state.currentSlide - additionalCount + childrenLen) % childrenLen;
	      var rightMostSlide = (this.state.currentSlide + additionalCount) % childrenLen;
	      if (!this.state.lazyLoadedList.includes(leftMostSlide)) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList + [leftMostSlide]
	        });
	      }
	      if (!this.state.lazyLoadedList.includes(rightMostSlide)) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList + [rightMostSlide]
	        });
	      }
	    }
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(213);
	
	var _helpers = __webpack_require__(141);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      if (!this.props.rtl) {
	        swipeLeft = curLeft + touchSwipeLength * positionOffset;
	      } else {
	        swipeLeft = curLeft - touchSwipeLength * positionOffset;
	      }
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var currentIndex = this.props.rtl === true ? this.state.slideCount - this.state.currentSlide : this.state.currentSlide;
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(213);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  // supposed to start autoplay of slides
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	      // this reference isn't lost due to mixin
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        var elem = slickList.querySelector(selector) || {};
	        slickList.style.height = (elem.offsetHeight || 0) + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      if (targetLeft === currentLeft) {
	        targetSlide = currentSlide;
	      }
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return 'left';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return 'right';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	exports.getPreClones = getPreClones;
	exports.getPostClones = getPostClones;
	exports.getTotalSlides = getTotalSlides;
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// checks if spec is the superset of keys in keysArray, i.e., spec contains all the keys from keysArray
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow; // this should probably be getTotalSlides
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	    trackWidth += spec.slideWidth / 2; // this is a temporary hack so that track div doesn't create new row for slight overflow
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	  if (spec.fade) {
	    style = {
	      opacity: 1
	    };
	  }
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    }
	    // shift current slide to center of the frame
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	    var lastSlide = _reactDom2.default.findDOMNode(trackRef).children[slideCount - 1];
	    var max = -lastSlide.offsetLeft + listWidth - lastSlide.offsetWidth;
	    if (slideCount <= slidesToShow || infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(trackRef).childNodes[slideIndex];
	    } else {
	      targetSlideIndex = slideIndex + slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (centerMode === true) {
	      if (infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(trackRef).children[slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(trackRef).children[slideIndex + slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	    if (spec.infinite === false && targetLeft < max) {
	      targetLeft = max;
	    }
	  }
	
	  return targetLeft;
	};
	
	function getPreClones(spec) {
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	}
	
	function getPostClones(spec) {
	  return spec.slideCount;
	}
	
	function getTotalSlides(spec) {
	  return getPreClones(spec) + spec.slideCount + getPostClones(spec);
	}

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(493);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(387);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(212);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(245);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(342);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    // javascript handler for  css media query
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      // sort them in increasing order of their numerical value
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        // media query for each breakpoint
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        // when not using server side rendering
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      // convert javascript object to media query string
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.slickPause = function slickPause() {
	    this.innerSlider.pause();
	  };
	
	  Slider.prototype.slickPlay = function slickPlay() {
	    this.innerSlider.autoPlay();
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      // never executes in the first render
	      // so defaultProps should be already there in this.props
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, _defaultProps2.default, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    // force scrolling by one if centerMode is on
	    if (settings.centerMode) {
	      if (settings.slidesToScroll > 1 && ("production") !== 'production') {
	        console.warn('slidesToScroll should be equal to 1 in centerMode, you are using ' + settings.slidesToScroll);
	      }
	      settings.slidesToScroll = 1;
	    }
	    // force showing one slide and scrolling by one if the fade mode is on
	    if (settings.fade) {
	      if (settings.slidesToShow > 1 && ("production") !== 'production') {
	        console.warn('slidesToShow should be equal to 1 when fade is true, you\'re using ' + settings.slidesToShow);
	      }
	      if (settings.slidesToScroll > 1 && ("production") !== 'production') {
	        console.warn('slidesToScroll should be equal to 1 when fade is true, you\'re using ' + settings.slidesToScroll);
	      }
	      settings.slidesToShow = 1;
	      settings.slidesToScroll = 1;
	    }
	
	    // makes sure that children is an array, even when there is only 1 child
	    var children = _react2.default.Children.toArray(this.props.children);
	
	    // Children may contain false or null, so we should filter them
	    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	    children = children.filter(function (child) {
	      if (typeof child === 'string') {
	        return !!child.trim();
	      }
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(3);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  // if spec has currentSlideIndex, we can also apply slickCurrent class according to that (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2300-L2302)
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    // if we're going right to left, index is reversed
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    // index of the slide
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0; // concern: not sure if this should be correct (https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L2328-L2346)
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    // concern: following can be incorrect in case where currentSlide is lastSlide in frame and rest of the slides to show have index smaller than currentSlideIndex
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var childrenCount = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    // in case of lazyLoad, whether or not we want to fetch the slide
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    // push a cloned element of the desired slide
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    // if slide needs to be precloned or postcloned
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	      if (preCloneNo <= spec.slidesToShow + (spec.centerMode ? 1 : 0) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    // var slides = renderSlides.call(this, this.props);
	    var slides = renderSlides(this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-43a433629edc6655a236.js